import { render, staticRenderFns } from "./pubDetail.vue?vue&type=template&id=a8060cc0&"
import script from "./pubDetail.vue?vue&type=script&lang=js&"
export * from "./pubDetail.vue?vue&type=script&lang=js&"
import style0 from "./pubDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports